import React from 'react';
import { AppModal } from './AppModal';
import { Button } from '../';
import { Form, Input, Space, Typography } from 'antd';
import { ValidationErrors } from '../../constants';

import { useResetPasswordCodeMutation } from '../../api/auth';

export const SendResetPasswordCodeModal = ({ open, onCancel, setShowResetPasswordModal }) => {
    const [form] = Form.useForm();
    const [resetPasswordCode, { isLoading }] = useResetPasswordCodeMutation();

    const onFinish = async () => {
        try {
            // This triggers the form validation, if not valid it jumps to the catch block below
            const { email } = await form.validateFields();
            let { token } = await resetPasswordCode({ email }).unwrap();
            sessionStorage.setItem('passwordResetToken', token);
            onCancel();
            setShowResetPasswordModal(true);
        } catch (error) {
            // We don't notify the user for having used the wrong email address
            onCancel();
            setShowResetPasswordModal(true);
        }
    };

    return (
        <AppModal
            title="Reset Password Code"
            onCancel={onCancel}
            open={open}
            header={true}
            footer={null}
            maskClosable={false}
        >
            <Typography.Paragraph>Please enter your email address below and press "Send Code".</Typography.Paragraph>
            <Typography.Paragraph>
                A password reset code will be sent to your email that you will then use to proceed with resetting your
                password.
            </Typography.Paragraph>

            <Form
                form={form}
                name="reset-password-code"
                layout="vertical"
                initialValues={{ remember: true }}
                style={{ maxWidth: 600 }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ type: 'email', required: true, message: ValidationErrors.email }]}
                >
                    <Input placeholder="Email" />
                </Form.Item>
                <Form.Item style={{ textAlign: 'right' }}>
                    <Space>
                        <Button key="cancel" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button key="submit" type="primary" loading={isLoading} htmlType="submit">
                            Send Code
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </AppModal>
    );
};
